import api from './api';

const invitationService = {
  getPendingInvitations: async () => {
    const response = await api.get('/invitations');
    return response.data;
  },

  getInvitationsByUserId: async (userId) => {
    const response = await api.get(`/invitations?userId=${userId}`);
    return response.data;
  },

  createInvitation: async (data) => {
    const response = await api.post('/invitations', data);
    return response.data;
  },

  acceptInvitation: async (id) => {
    const response = await api.post(`/invitations/${id}/accept`);
    return response.data;
  },

  declineInvitation: async (id) => {
    const response = await api.post(`/invitations/${id}/decline`);
    return response.data;
  },

  resendInvitation: async (id) => {
    const response = await api.post(`/invitations/${id}/resend`);
    return response.data;
  },

  cancelInvitation: async (id) => {
    const response = await api.delete(`/invitations/${id}`);
    return response.data;
  }
};

export default invitationService;
